import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import DropzoneTsoPq from '@components/Dropzone/Dropzone';
import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UploadListTsoPq from './UploadList';

type SelectFileTsoPqProps = {
  uploadingFiles: File[];
  handleFiles: (files: File[]) => void;
  removeFile: (fileToRemove: File) => void;
};

const StyledContent = styled(Box)(() => {
  return {
    width: '53.125rem',
    display: 'flex',
    flexDirection: 'column',
    padding: '1.5rem 0',
    gap: '1.25rem',
  };
});

const StyledDescritpion = styled(Typography)(() => {
  return {
    color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
    fontFamily: tsoPqTheme.typography.openSans,
    fontWeight: '400',
    fontSize: tsoPqTheme.typography.fontsize_support_support_text_medium,
    lineHeight: tsoPqTheme.typography.lineHeight_l,
    verticalAlign: 'middle',
    whiteSpace: 'pre-line',
  };
});

const StyledAddedList = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.125rem',
  };
});

const StyledUploadZone = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  };
});

const StyledTitle = styled(Typography)(() => {
  return {
    color: tsoPqTheme.palette.customTextColor.color_neutral_font_ft_nrtrl_hover,
    fontFamily: tsoPqTheme.typography.openSans,
    fontWeight: 500,
    fontSize: tsoPqTheme.typography.fontsize_title_list_section_small,
    lineHeight: tsoPqTheme.typography.lineHeight_m,
    verticalAlign: 'middle',
  };
});

const SelectFileTsoPq = ({ handleFiles, removeFile, uploadingFiles }: SelectFileTsoPqProps) => {
  const { t } = useTranslation();

  return (
    <StyledContent>
      <StyledUploadZone>
        <StyledDescritpion>{t('upload.fileUpload.selectFile.description')}</StyledDescritpion>
        <DropzoneTsoPq onFilesAccepted={handleFiles}></DropzoneTsoPq>
      </StyledUploadZone>
      {uploadingFiles.length > 0 && (
        <StyledAddedList>
          <StyledTitle>{t('upload.fileUpload.selectFile.added')}</StyledTitle>
          <UploadListTsoPq files={uploadingFiles} removeButtonAction={removeFile} removeButton />
        </StyledAddedList>
      )}
    </StyledContent>
  );
};

export default SelectFileTsoPq;
